import React from 'react';
import styled from 'styled-components';
import Logomark from '../lib/images/vista-logomark-colour.svg';

const StyledLogomark = styled.div`
    display: inline-block;
    text-align: center;
    width: 59px;
`;

export function VistaLogomark() {
    return (
        <StyledLogomark
            aria-label="Vista"
            dangerouslySetInnerHTML={{
                __html: Logomark,
            }}
        />
    );
}
